﻿
export function MapDestinationsElement() {
    return document.querySelector('#map_canvas');
}

export function hasMapDestinations() {
    let result =  (MapDestinationsElement() != null);
    console.log('>>> hasMapDestinations: ' + result);
    return result;
}

export function MapDestinationDestinationsElement() {
    return document.querySelector('#map_canvas_destinationDestinations');
}

export function hasMapDestinationDestinations() {
    let result = (MapDestinationDestinationsElement() != null);
    console.log('>>> hasMapDestinationDestinations: ' + result);
    return result;
}
